import { j as s } from "../chunks/index2.mjs";
import { forwardRef as O, useState as D, Fragment as as } from "react";
import { N as H, d as M, p as ls, V as is, R as ns, b as rs, h as os, f as W, T as z, g as U, i as q, P as G, e as J, O as Q, a as cs, A as X, S as ds, k as ts } from "../chunks/SocarImageList.mjs";
import { s as l, a as i, b as ms } from "../chunks/style.css.mjs";
const js = [
  "profile",
  "visitInfoForOwner",
  "mediaArea",
  "rating",
  "productNames",
  "visitKeywords",
  "title",
  "text",
  "translationButton",
  "votedKeywords",
  "paymentSummary",
  "beforeEtcArea",
  "etcArea",
  "reply",
  "ownerButtonArea",
  "place",
  "bottomArea"
], fs = ({
  votedKeywordsProps: c,
  profileProps: r,
  placeProps: d,
  title: a,
  textProps: e,
  productNames: t,
  rating: m,
  replyProps: j,
  paymentSummaryProps: f,
  visitInfoForOwnerProps: o,
  mediaArea: E,
  ownerButtonArea: h,
  translationButtonProps: w,
  etcArea: C,
  bottomArea: b,
  status: v = "ACTIVE",
  as: u,
  className: T,
  style: I,
  initialFolded: R = !0,
  beforeEtcArea: S,
  visitKeywordsProps: N,
  components: y = js,
  afterTextArea: F,
  legalNoticeProps: V,
  ...x
}, k) => {
  var K;
  const [p, Y] = D(R), B = ((K = e == null ? void 0 : e.foldableEllipsisProps) == null ? void 0 : K.foldable) ?? !0, A = () => {
    R && Y(!p);
  }, Z = (_, L) => {
    var n, g;
    (g = (n = e == null ? void 0 : e.foldableEllipsisProps) == null ? void 0 : n.onClickText) == null || g.call(n, _, L), A();
  }, P = (_, L) => {
    var n, g;
    (g = (n = e == null ? void 0 : e.foldableEllipsisProps) == null ? void 0 : n.onToggleButtonClick) == null || g.call(n, _, L), A();
  }, ss = v !== "ACTIVE", $ = u === "a" ? X : u || "li";
  if (ss)
    return /* @__PURE__ */ s.jsx($, { className: T ?? l.list_item, children: /* @__PURE__ */ s.jsx(H, { status: v, ...V }) });
  const es = {
    profile: r && /* @__PURE__ */ s.jsx(M, { ...r, className: ls(l.profile_area, r.className) }),
    visitInfoForOwner: o && /* @__PURE__ */ s.jsx(is, { ...o }),
    mediaArea: E,
    rating: m !== void 0 ? /* @__PURE__ */ s.jsx("div", { className: l.rating_area, children: /* @__PURE__ */ s.jsx(ns, { rating: m }) }) : null,
    productNames: t ? /* @__PURE__ */ s.jsx(rs, { names: t }) : null,
    visitKeywords: N && /* @__PURE__ */ s.jsx("div", { className: l.visit_keywords_wrapper, children: /* @__PURE__ */ s.jsx(os, { ...N, isFolded: p, onExpandClick: A }) }),
    title: a ? /* @__PURE__ */ s.jsx(W, { children: a }) : null,
    text: e && /* @__PURE__ */ s.jsx(
      z,
      {
        ...e,
        foldableEllipsisProps: {
          style: { lineHeight: "2.4rem" },
          // ReviewCard 프리셋 사용 시 style 오버라이드 방지를 위해 맨 위에 설정
          ...e.foldableEllipsisProps,
          isFolded: p,
          onClickText: B ? Z : void 0,
          onToggleButtonClick: B ? P : void 0
        }
      }
    ),
    afterTextArea: F,
    translationButton: w && /* @__PURE__ */ s.jsx("div", { className: l.translation_btn_area, children: /* @__PURE__ */ s.jsx(U, { ...w }) }),
    votedKeywords: c && /* @__PURE__ */ s.jsx(q, { ...c, isFolded: p, onExpandClick: A }),
    paymentSummary: f && /* @__PURE__ */ s.jsx("div", { className: l.payment_summary_area, children: /* @__PURE__ */ s.jsx(G, { ...f }) }),
    beforeEtcArea: S,
    etcArea: C ? /* @__PURE__ */ s.jsx("div", { className: l.etc_area, children: C }) : null,
    reply: j && /* @__PURE__ */ s.jsx(J, { className: l.reply_area, ...j }),
    ownerButtonArea: h ? /* @__PURE__ */ s.jsx("div", { className: l.owner_button_area, children: /* @__PURE__ */ s.jsx(Q, { children: h }) }) : null,
    place: d && /* @__PURE__ */ s.jsx(cs, { ...d }),
    bottomArea: b
  };
  return /* @__PURE__ */ s.jsx($, { className: T ?? l.list_item, ...x, style: I, ref: k, children: y.map((_) => /* @__PURE__ */ s.jsx(as, { children: es[_] }, _)) });
}, Cs = /* @__PURE__ */ O(fs), Es = Cs, us = ({
  votedKeywordsProps: c,
  profileProps: r,
  title: d,
  textProps: a,
  replyProps: e,
  paymentSummaryProps: t,
  translationButtonProps: m,
  mediaArea: j,
  ownerButtonArea: f,
  status: o = "ACTIVE",
  as: E,
  className: h,
  initialFolded: w = !0,
  foldable: C = !1,
  ...b
}, v) => {
  var y;
  const [u, T] = D(w), I = () => {
    C && T(!u);
  }, R = C || !!((y = a == null ? void 0 : a.foldableEllipsisProps) != null && y.onClickText), S = o !== "ACTIVE", N = E === "a" ? X : E || "div";
  return S ? /* @__PURE__ */ s.jsx(N, { className: h ?? i.list_item, ref: v, ...b, children: /* @__PURE__ */ s.jsx(H, { status: o }) }) : /* @__PURE__ */ s.jsxs(N, { className: h ?? i.list_item, ref: v, ...b, children: [
    r && /* @__PURE__ */ s.jsx(M, { size: "small", showRelationLabel: !1, className: i.profile_area, ...r }),
    /* @__PURE__ */ s.jsxs("div", { className: i.inner, children: [
      /* @__PURE__ */ s.jsxs("div", { className: i.info_area, children: [
        d ? /* @__PURE__ */ s.jsx(W, { children: d }) : null,
        a && /* @__PURE__ */ s.jsx(
          z,
          {
            ...a,
            foldableEllipsisProps: {
              style: { lineHeight: "2.4rem" },
              // ReviewCard 프리셋 사용 시 style 오버라이드 방지를 위해 맨 위에 설정
              showToggleButton: !1,
              foldable: C,
              isFolded: u,
              mergeLines: !0,
              ...a.foldableEllipsisProps,
              onClickText: R ? (F, V) => {
                var x, k;
                (k = (x = a.foldableEllipsisProps) == null ? void 0 : x.onClickText) == null || k.call(x, F, V), I();
              } : void 0
            }
          }
        ),
        m && /* @__PURE__ */ s.jsx("div", { className: i.translation_btn_area, children: /* @__PURE__ */ s.jsx(U, { ...m }) }),
        c && /* @__PURE__ */ s.jsx(
          q,
          {
            className: i.keyword_area,
            ...c,
            isFolded: u,
            onExpandClick: I
          }
        ),
        t && /* @__PURE__ */ s.jsx("div", { className: i.payment_summary_area, children: /* @__PURE__ */ s.jsx(G, { ...t }) })
      ] }),
      j && j
    ] }),
    e && /* @__PURE__ */ s.jsx(
      J,
      {
        className: i.reply_area,
        ...e,
        foldableEllipsisProps: {
          foldable: !1,
          isFolded: !0,
          mergeLines: !0,
          ...e.foldableEllipsisProps
        }
      }
    ),
    f ? /* @__PURE__ */ s.jsx("div", { className: i.owner_button_area, children: /* @__PURE__ */ s.jsx(Q, { children: f }) }) : null
  ] });
}, xs = /* @__PURE__ */ O(us), ws = xs, _s = /* @__PURE__ */ O(
  ({
    className: c,
    style: r,
    socarInfoProps: d,
    socarImageCardListProps: a,
    ...e
  }, t) => {
    const { ref: m, ...j } = d, { ref: f, ...o } = a || {};
    return /* @__PURE__ */ s.jsxs("li", { className: c ?? ms.list_item, ...e, style: r, ref: t, children: [
      /* @__PURE__ */ s.jsx(ds, { ...j, ref: m }),
      o && /* @__PURE__ */ s.jsx(ts, { ...o, ref: f })
    ] });
  }
), bs = _s;
export {
  ws as CompactReviewCard,
  js as REVIEW_CARD_DEFAULT_COMPONENTS,
  Es as ReviewCard,
  bs as SocarCard
};
